export const CARD_OPENING_TRANSITION_DURATION = 200;
export const CARD_OPENING_TRANSITION_DURATION_DELAYED = 1000;

export const rootElementId = 'root';

export enum BUTTON_VARIANT {
  primary = 'PRIMARY',
  danger = 'DANGER',
  success = 'SUCCESS',
}

export const nullString = '–';

export enum SORT_DIRECTION {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const cosunoDomains = ['cosuno.de', 'cosuno.com', 'cosuno-staging.com', 'cosuno-staging.de'];
export const uriSchemes = ['http://', 'https://', 'tel:', 'mailto:'];
